import { t, jt } from 'ttag'

import { SLR, SLR90T, WHITE } from '@h2/components/colors'
import walkthroughSvg from '@h2/assets/svg/illustrations/upTheLadder/earlyLearnersCtaWalkthroughVideo.svg'
import { PageArrowIcon } from '@h2/components/icons/pageArrow'

import { Cta } from './common/cta'

const brTag0 = <br key="brTag0" />
const brTag1 = <br key="brTag1" />
const walkthroughSpan = (
  <span key="resources">{jt`the${brTag0} walkthrough ${brTag1} video`}</span>
)
const Walkthrough = () => {
  return (
    <Cta bgColor={SLR90T} borderColor={SLR} bgImage={walkthroughSvg}>
      <Cta.Heading color={WHITE}>{jt`Review ${walkthroughSpan}`}</Cta.Heading>
      <Cta.Link
        ssr
        href="https://powerschool.shufflrr.com/s/522c81ac9e1f4ddaa588d07bda022310"
        icon={PageArrowIcon}>
        {t`Play`}
      </Cta.Link>
    </Cta>
  )
}

export { Walkthrough }
